export default {
      id: "menu-usage",
      viewBox: "0 0 384.97 384.97",
      url: "/assets/svg/" + "sprite.svg#menu-usage",
      toString: function () {
        return this.url;
      }
    }